export default __webpack_public_path__ + "static/media/blog18.1642caac.jpg";